<template>
  <div class="organization-manage app-region blank-l-h blank-r-h">
    <a-row :gutter="64" type="flex">
      <a-col :span="24" :xl="6" class="divide">
        <div class="page-title">组织架构</div>
        <a-row :gutter="16" type="flex" align="middle">
          <a-col flex="1">
            <a-input placeholder="请输入关键词" v-model="tree.keyword" @change="filterKeyword(tree.data, 'tree.searchData', tree.keyword, tree.params.title, tree.params.children)"></a-input>
          </a-col>
          <a-col>
            <a-icon type="plus" class="add-department" @click="addDepartment"></a-icon>
          </a-col>
        </a-row>
        <a-spin tip="加载中..." :spinning="tree.loading">
          <a-tree block-node :tree-data="tree.keyword ? tree.searchData : tree.data" :replaceFields="tree.params" @select="selectTreeNode" :expanded-keys="tree.expandedKeys" @expand="handleTreeExpand">
            <template slot="title" slot-scope="row">
              <a-row type="flex">
                <a-col flex="1">{{row[tree.params.title]}}</a-col>
                <a-col>
                  <a-dropdown>
                    <a-icon type="ellipsis"></a-icon>
                    <a-menu slot="overlay">
                      <a-menu-item @click="addDepartment(row)">添加子部门</a-menu-item>
                      <a-menu-item @click="changeDepartmentSuperior(row)">设置上级部门</a-menu-item>
                      <a-menu-item @click="editDepartment(row)">编辑部门</a-menu-item>
                      <a-menu-item @click="deleteDepartment(row)">删除部门</a-menu-item>
                    </a-menu>
                  </a-dropdown>
                </a-col>
              </a-row>
            </template>
          </a-tree>
        </a-spin>
      </a-col>
      <a-col :span="24" :xl="18">
        <div class="page-title">{{table.departmentName}}（{{table.page.total}}）</div>
        <a-row type="flex" align="bottom" :gutter="[16, 16]" class="mg-normal">
          <a-col :span="24" :xl="8">
            <a-row :gutter="[8, 8]">
              <a-col>
                <p>员工姓名</p>
              </a-col>
              <a-col>
                <a-input placeholder="请输入员工关键词" v-model="table.search.name"></a-input>
              </a-col>
            </a-row>
          </a-col>
          <a-col :span="24" :xl="8">
            <a-row :gutter="[8, 8]">
              <a-col>
                <p>手机号</p>
              </a-col>
              <a-col>
                <a-input placeholder="请输入手机号" v-model="table.search.phone"></a-input>
              </a-col>
            </a-row>
          </a-col>
          <a-col :span="24" :xl="8">
            <a-row :gutter="[8, 8]">
              <a-col>
                <p>职位</p>
              </a-col>
              <a-col>
                <a-input placeholder="请输入职位" v-model="table.search.position"></a-input>
              </a-col>
            </a-row>
          </a-col>
          <a-col :span="24" :xl="8">
            <a-space>
              <a-button type="primary" @click="searchTable">查询</a-button>
              <a-button @click="resetSearchTable">重置</a-button>
            </a-space>
          </a-col>
        </a-row>
        <a-row class="mg-normal">
          <a-col>
            <a-space>
              <a-button type="primary" @click="newStaff()">新增员工</a-button>
              <!-- <a-button>批量导入</a-button> -->
            </a-space>
          </a-col>
        </a-row>
        <a-table class="mg-normal" :loading="table.loading" :columns="table.columns" :data-source="table.data" rowKey="id" :pagination="table.page" @change="handlePageChange">
          <template slot="action" slot-scope="text, data">
            <a-space>
              <a-button type="link" @click="editStaff(data)">编辑</a-button>
              <a-button type="link" @click="deleteStaff(data)">删除</a-button>
            </a-space>
          </template>
        </a-table>
      </a-col>
    </a-row>
    <!-- 新增部门 -->
    <a-modal :title="addDepartmentModal.title" :confirm-loading="addDepartmentModal.loading" v-model="addDepartmentModal.show" @ok="confirmAddDepartmentModal" destroy-on-close centered>
      <a-form-model ref="form" :model="form" layout="vertical" :rules="rules">
        <a-form-model-item label="部门名称" prop="name">
          <a-input v-model="form.name" placeholder="请输入部门名称" allow-clear></a-input>
        </a-form-model-item>
      </a-form-model>
    </a-modal>
    <!-- 编辑部门 -->
    <a-modal :title="editDepartmentModal.title" :confirm-loading="editDepartmentModal.loading" v-model="editDepartmentModal.show" @ok="confirmEditDepartmentModal" destroy-on-close centered>
      <a-form-model ref="form" :model="form" layout="vertical" :rules="rules">
        <a-form-model-item label="部门名称" prop="name">
          <a-input v-model="form.name" placeholder="请输入部门名称" allow-clear></a-input>
        </a-form-model-item>
      </a-form-model>
    </a-modal>
    <!-- 设置上级部门 -->
    <a-modal :title="changeDepartmentSuperiorModal.title" :confirm-loading="changeDepartmentSuperiorModal.loading" v-model="changeDepartmentSuperiorModal.show" @ok="confirmChangeDepartmentSuperiorModal" destroy-on-close width="60%" centered>
      <a-row :gutter="[8, 8]">
        <a-col>
          <a-alert message="不选择部门则默认为根节点" type="warning" show-icon></a-alert>
        </a-col>
        <a-col>
          <tree-select v-model="changeDepartmentSuperiorModal.department" :data="tree.data" :params="tree.params">
            <template slot-scope="{row}">{{row[tree.params.title]}}</template>
          </tree-select>
        </a-col>
      </a-row>
    </a-modal>
  </div>
</template>

<script>
  import OrganizationService from '@/io/organization.js';

  export default {
    name: 'OrganizationManage',
    data() {
      let self = this;
      return {
        table: {
          departmentName: null,
          loading: false,
          search: {
            name: null,
            phone: null,
            position: null
          },
          page: {
            total: 0,
            current: 1,
            pageSize: 10,
            showQuickJumper: true,
            showSizeChanger: true,
            showTotal() {
              return `共${self.table.page.total}条`;
            }
          },
          data: [],
          columns: [
            {
              title: '姓名',
              dataIndex: 'name'
            },
            {
              title: '手机号',
              dataIndex: 'phone_number'
            },
            {
              title: '部门',
              dataIndex: 'department'
            },
            {
              title: '职位',
              dataIndex: 'position'
            },
            {
              title: '操作',
              dataIndex: 'action',
              scopedSlots: { customRender: 'action' },
            }
          ]
        },
        tree: {
          expandedKeys: [],
          selectedKeys: [],
          keyword: null,
          loading: false,
          data: [],
          searchData: [],
          params: {
            children: 'children',
            title: 'name',
            key: 'id'
          }
        },
        form: {
          name: null,
        },
        rules: {
          name: [
            {
              required: true,
              message: '请填写部门名称'
            }
          ]
        },
        addDepartmentModal: {
          id: null,
          title: '新增部门',
          show: false,
          loading: false
        },
        editDepartmentModal: {
          id: null,
          title: '编辑部门',
          show: false,
          loading: false
        },
        changeDepartmentSuperiorModal: {
          id: null,
          department: [],
          title: '设置上级部门',
          show: false,
          loading: false
        }
      }
    },
    mounted () {
      this.initTreeData();
      this.initDepartmentName();
    },
    activated() {
      this.initStaffData();
    },
    methods: {
      newStaff() {
        this.table.page.current = 1;
        this.$router.push('/platform/organization_manage/staff/new');
      },
      editStaff(data) {
        this.$router.push(`/platform/organization_manage/staff/edit/${data.id}`);
      },
      deleteStaff(data) {
        let self = this;
        this.$confirm({
          title: '提示',
          content: '确认删除此员工？',
          onOk() {
            OrganizationService.deleteStaff(data.id).then(res => {
              self.initStaffData();
            }).catch(err => {});
          }
        });
      },
      searchTable() {
        this.table.page.current = 1;
        this.initStaffData();
      },
      resetSearchTable() {
        this.table.search = {
          name: null,
          phone: null,
          position: null
        };
        this.searchTable();
      },
      handlePageChange(page) {
        this.table.page.current = page.current;
        this.table.page.pageSize = page.pageSize;
        this.initStaffData();
      },
      initDepartmentName() {
        let departmentName = '全部';
        this.$depthSearchTree(node => {
          if (node[this.tree.params.key] === this.tree.selectedKeys[0]) {
            departmentName = node[this.tree.params.title];
          }
        }, this.tree.data);
        this.table.departmentName = departmentName;
      },
      initStaffData() {
        this.table.loading = true;
        return OrganizationService.staffListPage(
          this.tree.selectedKeys[0],
          this.table.search.name,
          this.table.search.phone,
          this.table.search.position,
          this.table.page.current,
          this.table.page.pageSize
        ).then(res => {
          this.table.data = res.data.map(val => {
            val.department = val.tissue.map(m => m.name).join(',');
            return val;
          });
          this.table.page.total = res.meta.pagination.total;
        }).catch(err => {}).finally(() => {
          this.table.loading = false;
        });
      },
      initTreeData() {
        this.tree.loading = true;
        OrganizationService.companyList().then(res => {
          this.$depthSearchTree(node => {
            node.scopedSlots = {
              title: 'title'
            }
          }, res);
          this.tree.data = res;
        }).catch(err => {}).finally(() => {
          this.tree.loading = false;
        });
      },
      handleTreeExpand(expandedKeys) {
        this.tree.expandedKeys = expandedKeys;
      },
      selectTreeNode(selectedKeys) {
        this.tree.selectedKeys = selectedKeys;
        this.initDepartmentName();
        this.searchTable();
      },
      addDepartment(data = {}) {
        this.form.name = null;
        this.addDepartmentModal.id = data[this.tree.params.key];
        this.addDepartmentModal.show = true;
      },
      changeDepartmentSuperior(data) {
        let department = [];
        this.$depthSearchTree(node => {
          if (node[this.tree.params.key] === data.parent_id) {
            department = [node];
          }
        }, this.tree.data);
        this.changeDepartmentSuperiorModal.id = data[this.tree.params.key];
        this.changeDepartmentSuperiorModal.department = department;
        this.changeDepartmentSuperiorModal.show = true;
      },
      editDepartment(data) {
        this.form.name = data[this.tree.params.title];
        this.editDepartmentModal.id = data[this.tree.params.key];
        this.editDepartmentModal.show = true;
      },
      deleteDepartment(data) {
        let self = this;
        this.$confirm({
          title: '提示',
          content: '确认删除此部门？',
          onOk() {
            OrganizationService.deleteDepartment(data[self.tree.params.key]).then(res => {
              self.deleteTreeNode(data);
            }).catch(err => {});
          }
        });
      },
      confirmAddDepartmentModal() {
        this.$beforeFormSubmit(this.$refs.form, () => {
          this.addDepartmentModal.loading = true;
          OrganizationService.addDepartment(this.form.name, this.addDepartmentModal.id).then(res => {
            this.$afterFormSubmit('创建成功', () => {
              this.addTreeNode(res);
            });
          }).catch(err => {}).finally(() => {
            this.addDepartmentModal.show = false;
            this.addDepartmentModal.loading = false;
          });
        });
      },
      confirmEditDepartmentModal() {
        this.$beforeFormSubmit(this.$refs.form, () => {
          this.editDepartmentModal.loading = true;
          OrganizationService.editDepartment(this.editDepartmentModal.id, this.form.name).then(res => {
            this.$afterFormSubmit('编辑成功', () => {
              this.editTreeNode();
            });
          }).catch(err => {}).finally(() => {
            this.editDepartmentModal.show = false;
            this.editDepartmentModal.loading = false;
          });
        });
      },
      confirmChangeDepartmentSuperiorModal() {
        OrganizationService.changeDepartmentSuperior(this.changeDepartmentSuperiorModal.id, this.changeDepartmentSuperiorModal.department[0] ? this.changeDepartmentSuperiorModal.department[0][this.tree.params.key] : 0).then(res => {
          this.$afterFormSubmit('编辑成功', () => {
            this.initTreeData();
          });
        }).catch(err => {}).finally(() => {
          this.changeDepartmentSuperiorModal.show = false;
          this.changeDepartmentSuperiorModal.loading = false;
        });
      },
      addTreeNode(data) {
        data.scopedSlots = {
          title: 'title'
        };
        if (this.addDepartmentModal.id) {
          this.$depthSearchTree(node => {
            if (node[this.tree.params.key] === this.addDepartmentModal.id) {
              node.children.push(data);
              this.tree.expandedKeys.push(this.addDepartmentModal.id);
            }
          }, this.tree.data);
        } else {
          this.tree.data.push(data);
        }
      },
      editTreeNode() {
        this.$depthSearchTree(node => {
          if (node[this.tree.params.key] === this.editDepartmentModal.id) {
            node[this.tree.params.title] = this.form.name;
          }
        }, this.tree.data);
      },
      deleteTreeNode(data) {
        if (data.parent_id) {
          this.$depthSearchTree(node => {
            if (node[this.tree.params.key] === data.parent_id) {
              node.children.splice(node.children.map(val => val[this.tree.params.key]).indexOf(data[this.tree.params.key]), 1);
            }
            if (!node.children.length) {
              this.tree.expandedKeys.splice(this.tree.expandedKeys.indexOf(data.parent_id), 1);
            }
          }, this.tree.data);
        } else {
          this.tree.data.splice(data.position, 1);
        }
      }
    },
  }
</script>

<style lang="less" scoped>
  @import '../../assets/styles/tools.less';
  .organization-manage {
    .add-department {
      color: @primary-color;
      font-size: @font-size-lg;
      cursor: pointer;
    }
  }
</style>